import { render, staticRenderFns } from "./business-dresscode.vue?vue&type=template&id=5c958003"
import script from "./business-dresscode.vue?vue&type=script&lang=js"
export * from "./business-dresscode.vue?vue&type=script&lang=js"
import style0 from "./business-dresscode.vue?vue&type=style&index=0&id=5c958003&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports